var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefferal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 24H21V26H14V24ZM14 20H28V22H14V20ZM14 16H28V18H14V16ZM2 16V18H6.586L0 24.586L1.414 26L8 19.414V24H10V16H2ZM26 4H14L10.586 0.586C10.211 0.210901 9.70239 0.000113275 9.172 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V14H2V2H9.172L12.586 5.414L13.172 6H26V14H28V6C28 5.46957 27.7893 4.96086 27.4142 4.58579C27.0391 4.21071 26.5304 4 26 4Z",
    fill: "#192BC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefferal);
export default __webpack_public_path__ + "static/media/Refferal.5d5f6e6fd1ad13539afe1adb2cb6752d.svg";
export { ForwardRef as ReactComponent };